import { render, staticRenderFns } from "./receiveAccountsList.vue?vue&type=template&id=5061cdfc&scoped=true&"
import script from "./receiveAccountsList.vue?vue&type=script&lang=js&"
export * from "./receiveAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./receiveAccountsList.vue?vue&type=style&index=0&id=5061cdfc&lang=scss&scoped=true&"
import style1 from "./receiveAccountsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061cdfc",
  null
  
)

export default component.exports